import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Client } from "../domain/client";
import { Contract } from "../domain/contract";
import { User } from "../domain/user";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { AuthentificationDto } from "./DTO/authentification-dto";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
    providedIn: 'root',
})
export class UserConfigurationService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/user`;

    constructor(public http: HttpClient,
        protected coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected router: Router) {
        super(router, coreData, snackBare);
    }

    getAllUsers() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/All`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getAllUsers')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: User[]) => {
                return response.map((item: User) => {
                    return User.mapFromJSON(item);
                });
            }));
    }

    addClientToUser(client: Client, user: User) {
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/${user.Email}/Client`, JSON.stringify(client), this.generateHeader()).pipe(
            catchError(this.handleError<any>('addClientToUser')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

    deleteClientFromUser(client: Client, user: User) {
        this.loadingTask.activateLoading();
        return this.http.delete(`${this.serviceUrl}/${user.Email}/${client.Code}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('deleteClientFromUser')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }
    // Contract

    addContractToUser(contract: Contract, client: Client, user: User) {
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/${user.Email}/${client.Code}/Contract`, JSON.stringify(contract), this.generateHeader()).pipe(
            catchError(this.handleError<any>('addContractToUser')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

    deleteContractFromUser(contract: Contract, client: Client, user: User) {
        this.loadingTask.activateLoading();
        return this.http.delete(`${this.serviceUrl}/${user.Email}/${client.Code}/${contract.Code}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('deleteContractFromUser')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }
    // !Contract

    logInAs(email: string) {
        const dto: AuthentificationDto = new AuthentificationDto();
        dto.Email = email;
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/AuthenticationAs`, JSON.stringify(dto), this.generateHeader()).pipe(
            catchError(this.handleError<any>('logAs')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }

    createUser(user: User) {

        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}`, JSON.stringify(user), this.generateHeader()).pipe(
            catchError(this.handleError<any>('createUser')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

    updateUser(user: User) {

        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}`, JSON.stringify(user), this.generateHeader()).pipe(
            catchError(this.handleError<any>('updateUser')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

    deleteUser(user: User) {
        this.loadingTask.activateLoading();
        return this.http.delete(`${this.serviceUrl}/${encodeURI(user.Email)}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('deleteUser')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }
}